import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './logo.png'
import AAMC from './aamc.png'
import Services from '../../api/service';


const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const SubmitHandler = (e) => {
    e.preventDefault()
}

const Footer = (props) => {
    return (
        <footer class="wpo-site-footer">
  <div class="container">

    <div class="wpo-footer-inner">

      <div class="footer-logo">
      <img src={Logo} alt="logo" />

      </div>

      <nav class="footer-menu">
  <a href="/">Home</a>
  <a href="/service">Services</a>
  <a 
    href="https://lcs.cincwebaxis.com"
    target="_blank"
    rel="noopener noreferrer"
  >
    Pay Assessment
  </a>
  <a href="/about">About Us</a>
  <a href="/contact">Contact</a>
</nav>


       <div className="col-lg-12 text-center estimate-bar">
                                          <Link onClick={ClickHandler} className="footer-cta" to="/proposal">
          <span>Proposal Request</span>
      </Link>
      
      </div>
      <div className="footer-aamc text-center">
  <img src={AAMC} alt="AAMC Accredited" />
</div>
    </div>

    <div class="wpo-lower-footer">
      © 2025 Legacy Community Services — All Rights Reserved
    </div>

  </div>
</footer>
    )
}

export default Footer;